import { __assign, __awaiter, __generator } from "tslib";
import { OfficeRouteItemType, } from '@office-start/officehome-types';
import { getLaunchInstrumentationParamsFromKnownArea } from './getLaunchInstrumentationParamsFromKnownArea';
import { launchUrl } from './launchUrl';
export function launchMetaOSApp(appDetails, area) {
    return __awaiter(this, void 0, void 0, function () {
        var appId, entityId, subPageId, queryParams, officeRouteParams, route, param, action;
        return __generator(this, function (_a) {
            appId = appDetails.appId, entityId = appDetails.entityId, subPageId = appDetails.subPageId;
            queryParams = new URLSearchParams(location.search);
            officeRouteParams = __assign({}, queryParams);
            route = {
                route: 'M365Apps',
                type: OfficeRouteItemType.Mos,
                appId: appId,
                entityId: entityId,
                subPageId: subPageId,
            };
            param = getLaunchInstrumentationParamsFromKnownArea(area, undefined, entityId);
            action = 'OpenInBrowser';
            return [2 /*return*/, launchUrl(route, { action: action }, param, officeRouteParams)];
        });
    });
}
//# sourceMappingURL=launchMetaOSApp.js.map